module.exports = __webpack_public_path__ + "static/media/rc4.353bc303.jpg";